module.exports = __webpack_public_path__ + "media/images/start_footer-41a66e9f0f5235c6c02608b1eaaf11a2.webp";